module.exports = __webpack_public_path__ + "static/media/landing-vaccine-phone.790866fe.png";